import { SHARED_ACTIONS } from 'constants/Actions/Shared';

// Estado inicial del reducer
const aInitialState = {
    bLoading: false,
    nLoading: 0,
    sMessage: '',
    sMessageType: '',
    // Se ingresan las situaciones aquí mismo ya que el documento de especificaciones comenta que no cambiarán
    aSituations: [{ id: 0, name: 'Pendiente' }, { id: 1, name: 'Finalizado' }],
}
/**
 * Reducer que sera utilizado para controlar variables globales en el sistema, por ejemplo el loading.
 * 
 * @param {Array} oState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const SharedReducer = (oState = aInitialState, oAction) => {
    switch (oAction.type) {
        case SHARED_ACTIONS.MESSAGE:
            return { ...oState, bLoading: false, sMessage: oAction.sMessage, sMessageType: oAction.sMessageType };
        case SHARED_ACTIONS.CLEAN_MESSAGE:
            return aInitialState;
        case SHARED_ACTIONS.ACTIVE_LOADING:
            return { ...oState, bLoading: true, sMessage: '', style: '', nLoading: oState.nLoading + 1 };
        case SHARED_ACTIONS.DESACTIVE_LOADING:
            let nLoading = (oState.nLoading - 1) < 1 ? 0 : (oState.nLoading - 1);
            return { ...oState, bLoading: nLoading === 0 ? false : true, nLoading: nLoading };
        case SHARED_ACTIONS.CLEAN_LOADING:
            return { ...oState, bLoading: false, nLoading: 0 };
        default:
            return oState;
    }
}
